import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class MarketplaceProductResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  get() {
    return super
      .get()
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .patch(data, { url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }

  createVariant(data) {
    return super
      .post(data, { url: `${this.url}/variants` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  listVariants(params = { s: 100 }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/variants${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
